import React from "react";
import { useTranslation } from "react-i18next";
import { DangerOutlinedButton, SecondaryButton } from "src/ui/shared/CustomButton";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";

import { Box } from "@mui/material";

type Props = {
    clientId: string;
    isDeleting: boolean;
    onEdit: (clientId: string) => void;
    onDelete: (clientId: string) => void;
};

export const ActionCell = ({ clientId, isDeleting, onEdit, onDelete }: Props) => {
    const { t } = useTranslation(["common"]);
    return (
        <MinimalTableCell style={{ textAlign: "right", width: 80 }}>
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <SecondaryButton size="small" tooltipProps={{ title: t("common:button.edit") }} onClick={() => onEdit(clientId)}>
                    <i className="fa-solid fa-fw fa-pencil" />
                </SecondaryButton>
                <DangerOutlinedButton
                    size="small"
                    disabled={isDeleting}
                    tooltipProps={{ title: t("common:button.delete") }}
                    onClick={() => onDelete(clientId)}
                >
                    <i className="fa-solid fa-fw fa-trash" />
                </DangerOutlinedButton>
            </Box>
        </MinimalTableCell>
    );
};
